import { useEffect, useLayoutEffect, useState } from "react";
import { Alert, Button } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import ReactSelect from "react-select";
import MultiFileUploadS3 from "../../../../../core/components/core/Util/Form/CustomInputs/MultiFileUploadS3";
import Fetch from "../../../../../core/util/core/Fetch";
import { getUserSession } from "../../../../../core/util/core/Session";
import config from "../../../../../application/config/config";
import { Message } from "./Message";
import "./styles.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faComment } from '@fortawesome/free-regular-svg-icons';
import { faX } from '@fortawesome/free-solid-svg-icons';
import { useKeysStore } from "../../../../store/useKeysStore";

export const truncateLongFileNames = (filename, max = 15, end = "...") => (
    filename.length <= max ? filename : filename.substring(0, max - end.length) + end
);

function DirectChat() {
    const SOLVED_STATUS_ID = 'aea03fe3-e168-4213-a8fd-a02b18fcef12';
    const {keys} = useKeysStore();

    const [messages, setMessages] = useState([]);
    const [request, setRequest] = useState();
    const [options, setOptions] = useState([]);
    const [isSupportProfile, setIsSupportProfile] = useState(false);
    const [newMessage, setNewMessage] = useState("");
    const [defaultValue, setDefaultValue] = useState();
    const [files, setFiles] = useState([])
    const [selectedOption, setSelectedOption] = useState();
    const [key, setKey] = useState(0);

    const session = getUserSession();
    const params = useParams();
    const navigate = useNavigate();

    const scrollToBottom = () => {
        const chatHeight = document.querySelector(".direct-chat-messages");
        chatHeight.scrollTo(0, chatHeight.scrollHeight)
    }

    const handleOnChange = (event) => {
        setNewMessage(event.target.value)
        if (newMessage.length === 500) {
            scrollToBottom();
        }
    }

    const deleteFile = (fileToDelete) => setFiles(files.filter(file => file !== fileToDelete))

    const getFiles = (_, files) => {
        setFiles(files);
    }

    const setDefaultValueBasedOnStatus = () => {
        if (request && options.length > 0) {

            const value = options.find((option) => {

                if (option.label == request.status_name) {
                    return option;
                }
            })

            setDefaultValue(value);
        }
    }

    const getMessages = async () => {
        const messageParams = {
            id: params.id,
            core_application_instance_id: session.user.application_instance_id
        }
        const data = await Fetch.post(`${config.endpoints.backend}core/supportinteractions/getall`, messageParams);
        setMessages(data);
    }

    const getRequest = async () => {
        const data = await Fetch.post(`${config.endpoints.backend}core/supportrequests/getById`, { id: params.id })
        setRequest(data);
    }

    const getOptions = async () => {
        const data = await Fetch.post(`${config.endpoints.backend}core/supportstatus/getall`)
        setOptions(data);
    }
    
    const getIsSupportProfile = async () => {
        const data = await Fetch.post(`${config.endpoints.backend}core/supportrequests/verifySupportProfile`, {
            core_application_profile_id: session.user.application_profile_id
        })
        setIsSupportProfile(data);
    }

    const onUpdateStatus = async () => {
        if (selectedOption) {

            const requestData = {
                core_support_status_id: selectedOption.value,
                id: request.id
            }

            const solvedRequestData = {
                core_support_status_id: SOLVED_STATUS_ID,
                id: request.id,
                closed: new Date().getTime()
            }

            if (selectedOption.value === SOLVED_STATUS_ID) {
                await Fetch.put(`${config.endpoints.backend}core/supportrequests/save`, solvedRequestData);
            } else {
                await Fetch.put(`${config.endpoints.backend}core/supportrequests/save`, requestData);
            }
        } else if (defaultValue) {

            await Fetch.put(`${config.endpoints.backend}core/supportrequests/save`, {
                core_support_status_id: defaultValue.value,
                id: request.id
            })
        }
    }


    const handleOnSubmit = async (event) => {
        event.preventDefault();
        const isMessageValid = newMessage && newMessage.trim().length >= 1 && newMessage.length <= 500;
        const canSendMessage = isMessageValid || files && files.length > 0 && request && defaultValue;
        if (canSendMessage) {

            const messageData = {
                core_user_id: session.user.id,
                message: newMessage,
                files,
                core_application_instance_id: session.user.application_instance_id,
                core_support_request_id: params.id,
            }

            await Fetch.post(`${config.endpoints.backend}core/supportinteractions/save`, messageData)

            getMessages();

            setNewMessage("");
            setFiles([]);

            // forces update in multifiles3 component to clean current files
            setKey(prevKey => prevKey + 1);
        }

    }

    useLayoutEffect(() => {
        getMessages()
        getRequest()
        getOptions()
        getIsSupportProfile()
        scrollToBottom()
    }, [])

    useEffect(() => {
        if (messages.length > 0) {
            scrollToBottom()
        }
    }, [messages])

    useEffect(() => {
        setDefaultValueBasedOnStatus();
    }, [options, request])

    useEffect(() => {
        onUpdateStatus();
    }, [selectedOption])

    return (
        <div className="col-11 row-10 container">
            <div className="pre-header">
                <div>
                    <Button className="my-2" onClick={() => navigate("/core/support/list")}>Voltar</Button>
                </div>
                {options.length > 0 && defaultValue && (session.user.application_profile_id == keys?.default_foreign_key?.profiles?.admin || isSupportProfile) && (
                    <>
                        <div className="vr"></div>
                        <form>
                            <ReactSelect
                                options={options}
                                defaultValue={defaultValue}
                                onChange={option => setSelectedOption(option)}
                                isDisabled={defaultValue.value == SOLVED_STATUS_ID ? true : false}
                            />
                        </form>
                    </>
                )}
            </div>
            <div className="card card-primary card-outline direct-chat direct-chat-primary chat">
                {request && (
                    <div className="request-header">
                        <div>
                            <FontAwesomeIcon icon={faComment} />
                            <div>
                                <h1>{request.title}</h1>
                                <p>por <strong>{request.user_name}</strong></p>
                                <div>
                                    <p>Email: <strong>{request.user_email || 'Indisponível'}</strong></p>
                                </div>
                            </div>
                        </div>
                        <div>
                            <p>Incidência: <strong>{request.incidence_name}</strong></p>
                            <div className="vr"></div>
                            <p>N° do Chamado: <strong>{request.counter}</strong></p>
                            <div className="vr"></div>
                            <p>Suporte aberto em:<br /><strong>{request.created_at}</strong></p>
                        </div>
                    </div>
                )}

                <div className="card-body custom-card-body">
                    <div className="direct-chat-messages" style={{ height: '100%' }}>
                        {messages && messages.map((message) => (
                            message.core_user_id != session.user.id ? (
                                <Message message={message} isCurrentUser={true} />
                            ) : (
                                <div className="message-container">
                                    <Message message={message} isCurrentUser={false} />
                                </div>
                            )
                        ))}
                    </div>
                </div>
                <div className="card-footer">
                    {defaultValue && request && defaultValue.value != SOLVED_STATUS_ID ? (
                        <>
                            <form onSubmit={handleOnSubmit}>
                                <MultiFileUploadS3 useIcon showUploads={false} path="support_interactions" onUpload={getFiles} key={key} />

                                <div className="input-and-alerts">
                                    {newMessage.length === 500 ? <Alert variant="danger" className="limit-message-alert col-3">
                                        Limite de caracteres atingido!
                                    </Alert> : <span className="small text-muted">Caracteres restantes: {500 - newMessage.length}</span>}

                                    <div className="input-group">
                                        <input type="text" name="message" autoComplete="off" placeholder="Digite a mensagem..." className="form-control" onChange={handleOnChange} value={newMessage} maxlength="500" />
                                        <span className="ml-2">
                                            <button type="button" className="btn btn-primary px-4" onClick={handleOnSubmit}>Enviar</button>
                                        </span>
                                    </div>
                                </div>

                            </form>
                            <div className="files-uploades-list">
                                {files.map(f => (
                                    <span>
                                        <a href={f.files3} target="_blank" rel="noopener noreferrer">{truncateLongFileNames(f.filename)}</a>
                                        <button onClick={() => deleteFile(f)}><FontAwesomeIcon icon={faX} /></button>
                                    </span>
                                ))}
                            </div>
                        </>
                    ) : <p>Chamado Finalizado em {request && request.closed}</p>}
                </div>
            </div>
        </div>

    );
}

export default DirectChat;